'use strict';

var React = require('react'),
    LightboxStore = require('../stores/LightboxStore'),
    PageControlsStore = require('../stores/PageControlsStore'),
    PageControlsTypes = require('../constants/PageControlsTypes'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    StampPageControls = require('../pageControls/StampPageControls'),
    StampReviewPageControls = require('../pageControls/StampReviewPageControls'),
    ZinePageControls = require('../pageControls/ZinePageControls'),
    ZineEditPageControls = require('../pageControls/ZineEditPageControls'),
    DraftPreviewPageControls = require('../pageControls/DraftPreviewPageControls'),
    DraftComposePageControls = require('../pageControls/DraftComposePageControls'),
    UserPageControls = require('../pageControls/UserPageControls'),
    ImagePageControls = require('../pageControls/ImagePageControls'),
    DraftFeedbackControls = require('../pageControls/DraftFeedbackControls'),
    TimeoutTransitionGroup = require('../utils/TimeoutTransitionGroup');

var PageControlsHost = React.createClass({
  mixins: [createStoreMixin(PageControlsStore, LightboxStore), PureRenderMixin],

  getStateFromStores() {
    return {
      pageControls: PageControlsStore.getPageControls()
    };
  },

  render() {
    return (
      <TimeoutTransitionGroup transitionName='PageControls'
                              enterTimeout={300 + 300}
                              leaveTimeout={300}>
        {this.renderPageControls()}
      </TimeoutTransitionGroup>
    );
  },

  renderPageControls() {
    var { pageControls } = this.state;
    if (!pageControls) {
      return null;
    }

    switch (pageControls.id) {
    case PageControlsTypes.STAMP:
      return (
        <StampPageControls key={'stamp-' + pageControls.stampId}
                           stampId={pageControls.stampId} />
      );

    case PageControlsTypes.STAMP_REVIEW:
      return (
        <StampReviewPageControls key={'stampReview-' + pageControls.stampId}
                                  stampId={pageControls.stampId}
                                  zineSlug={pageControls.zineSlug} />
      );

    case PageControlsTypes.ZINE:
      return (
        <ZinePageControls key={'zine-' + pageControls.zineSlug}
                          zineSlug={pageControls.zineSlug} />
      );

    case PageControlsTypes.ZINE_EDIT:
      return (
        <ZineEditPageControls key={'zineEdit-' + (pageControls.zineSlug || 'new')} />
      );

    case PageControlsTypes.DRAFT_COMPOSE:
      return (
        <DraftComposePageControls key='draftCompose'
                                  stampSegment={pageControls.stampSegment} />
      );

    case PageControlsTypes.DRAFT_PREVIEW:
      return (
        <DraftPreviewPageControls key='draftPreview'
                                  stampSegment={pageControls.stampSegment} />
      );

    case PageControlsTypes.DRAFT_FEEDBACK:
      return (
        <DraftFeedbackControls key='draftFeedback'
                               draftUuid={pageControls.draftUuid} />
      );

    case PageControlsTypes.USER:
      return (
        <UserPageControls key={'user-' + pageControls.userId}
                          userId={pageControls.userId} />
      );

    case PageControlsTypes.IMAGE:
      return (
        <ImagePageControls key={'image-' + pageControls.imageUuid}
                           stampId={pageControls.stampId}
                           imageUuid={pageControls.imageUuid}
                           sectionType={pageControls.sectionType} />
      );
    }
  }
});

module.exports = PageControlsHost;



/** WEBPACK FOOTER **
 ** ./hosts/PageControlsHost.jsx
 **/